module.exports = __webpack_public_path__ + "assets/images/attachment.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/attachment.png
// module id = 1485
// module chunks = 1